import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { components, paths } from '../../generated/portal-api';

type QueryParams = NonNullable<paths['/api/subscriptions/{vertical}']['get']['parameters']['query']>;

export function createUnsubscribeApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		subscriptions(vertical: components['schemas']['ComPrefsVertical'], queryParams: QueryParams) {
			return client.GET('/api/subscriptions/{vertical}', {
				params: {
					path: { vertical },
					query: queryParams,
				},
			});
		},

		setSubscriptions(request: components['schemas']['EditSubscriptionsRequestModel']) {
			return client.POST('/api/subscriptions', { body: request });
		},
	};
}
